import React, { useEffect, useState, useCallback } from "react";
import { useFormikContext } from "formik";
import {
  IconButton,
  Text,
  Flex,
  Box,
  Grid,
  GridItem,
  Button,
} from "@chakra-ui/react";

import { BsFillTrash3Fill } from "react-icons/bs";
import { CustomSelectWField } from "../CustomSelectWField";

import { CustomDatepickerWField } from "../CustomDatepickerWField";

import { CustomTextArea } from "../CustomTextArea";
import Swal from "sweetalert2";
import { CustomInputWField } from "../CustomInputWField";
import { forNames } from "../../utils/masks";

const CustomFormApadriamento = ({
  dataFimApadrinhamentoStatus,
  dataInicioApadrinhamentoStatus,
}) => {
  const [tiposApadrinhamento, setTiposApadrinhamento] = useState({
    options: [],
    isLoading: false,
  });
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);

  const { values, setFieldValue } = useFormikContext();
  const [componentes, setComponentes] = useState(
    values.pessoasProgramaApadrinhamento
  );

  useEffect(() => {
    setComponentes(values.pessoasProgramaApadrinhamento || []);
  }, [values.pessoasProgramaApadrinhamento]);

  const handleAddComponente = () => {
    const novoComponente = {
      tipoPessoaProgApadrinha: "",
      nomePessoaApadrinhamento: "",
      dataInicioApadrinhamento: "",
      dataFimApadrinhamento: "",
      informacaoComplementar: "",
      id: 0,
    };
    if (componentes.length === 0) {
      setComponentes([novoComponente]);
      setFieldValue("pessoasProgramaApadrinhamento", [novoComponente]);
    } else {
      setComponentes([...componentes, novoComponente]);
      setFieldValue("pessoasProgramaApadrinhamento", [
        ...componentes,
        novoComponente,
      ]);
    }
  };

  const handleRemoveComponente = (index) => {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir o apadrinhamento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedComponentes = componentes.filter((_, i) => i !== index);
        setComponentes(updatedComponentes);
        setFieldValue("pessoasProgramaApadrinhamento", updatedComponentes);

        if (updatedComponentes.length === 0) {
          setFieldValue("pessoasProgramaApadrinhamento", []);
        }
      }
    });
  };

  const handleChange = (index, fieldName, value) => {
    const currentComponent = componentes[index];

    const updatedComponent = {
      ...currentComponent,
      [fieldName]: value,
    };

    const updatedComponentes = [...componentes];
    updatedComponentes[index] = updatedComponent;

    setComponentes(updatedComponentes);

    setFieldValue(`pessoasProgramaApadrinhamento[${index}]`, updatedComponent);
  };

  const handleGetTipoApadrinhamento = useCallback(() => {
    const modifiedData = [
      { idTipo: 1, descricaoTipo: "Padrinho (Programa)" },
      { idTipo: 2, descricaoTipo: "Madrinha (Programa)" },
    ];
    setTiposApadrinhamento({ options: modifiedData, isLoading: false });
  }, []);

  useEffect(() => {
    handleGetTipoApadrinhamento();
  }, [handleGetTipoApadrinhamento]);

  return (
    <Box>
      {componentes &&
        componentes.length > 0 &&
        componentes.map((componente, index) => (
          <Grid
            key={index}
            templateColumns="repeat(20, 1fr)"
            gap={4}
            mt={index > 0 ? 6 : 2}
          >
            <GridItem colSpan={19}>
              <Grid
                templateColumns="repeat(4, 1fr) 1fr"
                key={index}
                gap={{ base: 10, xl: 25 }}
                border={"1px solid #DDEBEA"}
                px={2}
                py={4}
                justifyContent={"space-between"}
              >
                <GridItem colSpan={{ base: 5, md: 5, lg: 3, xl: 2 }}>
                  <CustomSelectWField
                    fieldName={`pessoasProgramaApadrinhamento[${index}].tipoPessoaProgApadrinha`}
                    label="Tipo*"
                    placeholder="Selecione o Tipo"
                    getOptionLabel={(option) =>
                      option.descricaoTipo || option.descricao
                    }
                    getOptionValue={(option) => option.idTipo}
                    isLoading={tiposApadrinhamento.isLoading}
                    options={tiposApadrinhamento.options}
                    values={componente.pessoasProgramaApadrinhamento}
                    onChange={(value) => {
                      handleChange(index, "tipoPessoaProgApadrinha", value);
                    }}
                    onFocus={
                      tiposApadrinhamento.options.length === 0
                        ? handleGetTipoApadrinhamento
                        : null
                    }
                    visible={values.sendoApadrinhado === "S"}
                  />
                </GridItem>
                <GridItem colSpan={{ base: 5, lg: 1, xl: 1 }}>
                  <CustomDatepickerWField
                    fieldName={`pessoasProgramaApadrinhamento[${index}].dataInicioApadrinhamento`}
                    label="Data Início do Apadrinhamento*"
                    placeholder="DD/MM/AAAA"
                    maxDate={new Date()}
                  />

                  {dataInicioApadrinhamentoStatus?.[index]?.menor && (
                    <Text
                      mt="8px"
                      color="#E53E3E"
                      fontSize="sm"
                      lineHeight={"normal"}
                    >
                      A data do início do apadrinhamento não pode ser menor que
                      a data do primeiro acolhimento.
                    </Text>
                  )}

                  {dataInicioApadrinhamentoStatus?.[index]?.futura && (
                    <Text
                      mt="8px"
                      color="#E53E3E"
                      fontSize="sm"
                      lineHeight={"normal"}
                    >
                      A data informada não pode ser uma data futura!
                    </Text>
                  )}
                </GridItem>
                <GridItem colSpan={{ base: 5, lg: 1 }}>
                  <CustomDatepickerWField
                    fieldName={`pessoasProgramaApadrinhamento[${index}].dataFimApadrinhamento`}
                    label="Data Fim do Apadrinhamento"
                    placeholder="DD/MM/AAAA"
                  />
                  {dataFimApadrinhamentoStatus?.[index]?.menor && (
                    <Text
                      mt="8px"
                      color="#E53E3E"
                      fontSize="sm"
                      lineHeight={"normal"}
                    >
                      A data fim do apadrinhamento não pode ser menor que a data
                      do início do apadrinhamento!
                    </Text>
                  )}
                </GridItem>

                <GridItem colSpan={{ base: 5, md: 5, xl: 5 }}>
                  <CustomInputWField
                    fieldName={`pessoasProgramaApadrinhamento[${index}].nomePessoaApadrinhamento`}
                    label="Nome*"
                    placeholder="Informe o Nome do Padrinho ou da Madrinha"
                    onChange={(e) =>
                      setFieldValue(
                        `pessoasProgramaApadrinhamento[${index}].nomePessoaApadrinhamento`,
                        forNames(e.target.value)
                      )
                    }
                  />
                </GridItem>

                <GridItem colSpan={5}>
                  <CustomTextArea
                    fieldName={`pessoasProgramaApadrinhamento[${index}].informacaoComplementar`}
                    label={"Informações Complementares"}
                    placeholder={"Informe as Informações Complementares"}
                    setIsTextareaFocused={setIsTextareaFocused}
                    maxLength={255}
                    isTextareaFocused={isTextareaFocused}
                    fontWeightLabel={500}
                    colorLabel="#5F6377"
                    fontSizeLabel={"14px"}
                    lineHeightLabel={"19.6px"}
                  />
                </GridItem>
              </Grid>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex alignItems={"center"} h={"full"}>
                <IconButton
                  icon={<BsFillTrash3Fill size={20} color="#9EA1AE" />}
                  aria-label="Excluir"
                  bg="transparent"
                  _hover={{ bg: "transparent" }}
                  size="sm"
                  onClick={() => handleRemoveComponente(index)}
                />
              </Flex>
            </GridItem>
          </Grid>
        ))}

      {componentes && componentes.length <= 0 && (
        <Text color="red" opacity={0.8} fontSize="12px">
          Por favor, adicione e informe o apadrinhamento
        </Text>
      )}
      <Button
        onClick={handleAddComponente}
        mt="13px"
        py="5px"
        px="16px"
        h="32px"
        color="#FFF"
        backgroundColor="#169499"
        fontWeight={700}
        fontSize="15px"
        lineHeight="21.6px"
        _hover={{ bg: "#169499" }}
      >
        Adicionar
      </Button>
    </Box>
  );
};

export default CustomFormApadriamento;
